import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { Department } from '../models/peru-location.model';

@Injectable({ providedIn: 'root' })
export class PeruLocationApi {
  private httpClient = inject(HttpClient);

  private departmentsRequest$ = this.httpClient
    .get<Department[]>('/shared/data/peru-departments.json')
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  getDepartments() {
    return this.departmentsRequest$;
  }
}
